import Axios from "axios";

export default {
  getAllBroker() {
    return Axios.get("/comun/getBrokersAgencies");
  },
  getAgencies() {
    return Axios.get("/comun/getAgencies");
  },
  getAgents() {
    return Axios.get("/comun/getAgents");
  },
  getExternalAgents(userID)
  {
    return Axios.get("/comun/getAgentsData?user_id="+userID);
  },
  validateIdentification(identification){
    return Axios.get("/comun/validateIdentification?identification=" + identification)
  }
};